import React from 'react';
import { Form as FormRS, Col, FormGroup, Button, Alert } from 'reactstrap';
import { useConfig } from '~/hooks';
import { Form as FormRFF } from 'react-final-form';
import { PropTypes } from '~/utils';
import { validate } from './validation';
import { FormField } from './FormField';

export function Form( props ) {
  const { onSubmit, fields, validate : validator } = props;
  const config = useConfig();

  return (
    <FormRFF
      onSubmit={onSubmit}
      validate={ ( values ) => validate( fields, validator, values ) }
      render={ ( opts ) => {
        const {
          handleSubmit, invalid, submitting, submitError,
          /* reset, pristine, values, validating, valid */
        } = opts;
        const formprops = {
          onSubmit    : handleSubmit,
        };
        // disable autocomplete when on a station
        if ( config.get( 'station' ) ) formprops.autoComplete = 'off';
        return (
          <FormRS {...formprops}>
            { submitError && <Alert color="danger">{submitError}</Alert> }
            { fields.map( f => ( <FormField key={f.name} {...f} /> ) ) }
            <FormGroup check row>
              <Col sm={{ size : 10, offset : 2 }}>
                <Button
                  className="focusable"
                  type="submit"
                  color="primary"
                  size="lg"
                  block
                  disabled={invalid || submitting}
                >Submit</Button>

                {/*
                <Button
                  classname="focusable"
                  onClick={reset}
                  disabled={submitting || pristine}
                >Reset</Button>
                */}

              </Col>
            </FormGroup>
          </FormRS>
        );
      } }
    />
  );
}
Form.propTypes = {
  fields      : PropTypes.arrayOf( PropTypes.shape( FormField.propTypes ) ),
  onSubmit    : PropTypes.func.isRequired,
  validate    : PropTypes.func,
};
